import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row, Spinner } from "reactstrap";
import { getDashboardStats } from "../../api/pagination";
import { FiDollarSign, FiShoppingCart, FiBox, FiUsers } from "react-icons/fi";
import RevenueChart from "../../components/dashboard/RevenueChart";
import OrderStatusChart from "../../components/dashboard/OrderStatusChart";

import TotalSales from "../../components/dashboard/TotalSales";
import PageName from "../../components/react_helmet/PageName";
import { AllDashboardStats } from "../../store/actions/actions";
import DashboardSkeleton from "../../components/skeleton/DashboardSkeleton";
const Dashboard = () => {
  const dispatch = useDispatch();
  const { statsData } = useSelector((state) => state.redux);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(false);
  const formatNumber = (num) => {
    if (num >= 1_000_000_000) {
      return `$ ${(num / 1_000_000_000).toFixed(1)}B`;
    } else if (num >= 1_000_000) {
      return `$ ${(num / 1_000_000).toFixed(1)}M`;
    } else if (num >= 1_000) {
      return `$ ${(num / 1_000).toFixed(1)}K`;
    } else {
      return `$ ${num?.toFixed(2)}`;
    }
  };
  const todaySales = [
    {
      title: `${stats?.totals?.totalSales ? formatNumber(stats?.totals?.totalSales) : 0}`,
      subTitle: "Total Sales",
      icon: FiDollarSign,
      percent: "Current Month Sales",
      colorClass: "bg-primary-light",
    },
    {
      title: stats?.totals?.totalOrders ?? 0,
      subTitle: "Total Orders",
      icon: FiShoppingCart,
      percent: "Order of current Month",
      colorClass: "bg-success-light",
    },
    {
      title: stats?.totals?.totalProducts ?? 0,
      subTitle: "All Products",
      icon: FiBox,
      percent: "Items of current Month",
      colorClass: "bg-warning-light",
    },
    {
      title: stats?.totals?.totalCustomers ?? 0,
      subTitle: "All Customers",
      icon: FiUsers,
      percent: "Customers of current Month",
      colorClass: "bg-info-light",
    },
  ];
  useEffect(() => {
    if (!statsData) {
      setLoading(true);
      getDashboardStats("", (res) => {
        if (res?.status === 200) {
          dispatch(AllDashboardStats(res?.data?.data));
        }
        setLoading(false);
      });
    }
  }, [dispatch, statsData]);
  useEffect(() => {
    if (statsData) {
      setStats(statsData);
    }
  }, [statsData]);
  if (loading) {
    return <DashboardSkeleton />;
  }
  return (
    <div className="dashboard-container">
      <PageName title={"Dashboard"} />
      <Row className="dashboard">
        <Col md={12} sm={12}>
          <TotalSales todaySales={todaySales} />
        </Col>
      </Row>
      <Row className="mt-4">
        <Col md={8} sm={12} className="mb-4 mb-md-0">
          <RevenueChart />
        </Col>
        <Col md={4} sm={12}>
          <OrderStatusChart />
        </Col>
      </Row>

    </div>
  );
};
export default Dashboard;
